/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface SmsPostRequest
 */
export interface SmsPostRequest {
  /**
   * If truthy, simulate the sms callbacks instead of sending a real sms
   * @type {any | null}
   * @memberof SmsPostRequest
   */
  fake?: any | null;
  /**
   * the LeadListItem.id to send an SMS from
   * @type {string}
   * @memberof SmsPostRequest
   */
  itemId: string;
  /**
   * the body of the text message
   * @type {string}
   * @memberof SmsPostRequest
   */
  text?: string;
}

/**
 * Check if a given object implements the SmsPostRequest interface.
 */
export function instanceOfSmsPostRequest(
  value: object,
): value is SmsPostRequest {
  if (!('itemId' in value) || value['itemId'] === undefined) return false;
  return true;
}

export function SmsPostRequestFromJSON(json: any): SmsPostRequest {
  return SmsPostRequestFromJSONTyped(json, false);
}

export function SmsPostRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SmsPostRequest {
  if (json == null) {
    return json;
  }
  return {
    fake: json['fake'] == null ? undefined : json['fake'],
    itemId: json['item_id'],
    text: json['text'] == null ? undefined : json['text'],
  };
}

export function SmsPostRequestToJSON(value?: SmsPostRequest | null): any {
  if (value == null) {
    return value;
  }
  return {
    fake: value['fake'],
    item_id: value['itemId'],
    text: value['text'],
  };
}
